export type LanguageCode = "de" | "en";

export type LabelKey =
    "map.toggle.map"
    | "map.toggle.list"
    | "map.show_on_map"
    | "map.goto_report"
    | "immo.size"
    | "immo.type_of_use"
    | "immo.situation"
    | "immo.available_area"
    | "immo.priority_trade"
    | "immo.availability"
    ;

export class Label {

    public static lookup: { [key: string]: string } = {};
    public static language: LanguageCode = "de";

    public static text(key: LabelKey, fallback: string = "", language: LanguageCode = null): string {

        if (!language) {
            language = this.language;
        }
        var v = this.lookup[language + "." + key];

        if (v === undefined

        ) {
            console.warn("Could not resolve label:", key);
        }

        if (window.bisBase
            && window.bisBase.showLabelKeys) {
            return key;
        }

        return v === undefined ? fallback : v;
    }

    public static html(key: LabelKey, fallback: string = "", language: LanguageCode = null): string {
        return e5.Text.escapeHtml(this.text(key, fallback, language));
    }

    public static parse(labels: VOLabel[]): void {
        var lookup: { [key: string]: string } = {};
        for (var label of labels) {
            if (label.labels) {
                for (var l of label.labels) {
                    lookup["de." + label.title + "." + l.key] = l.de || l.en;
                    lookup["en." + label.title + "." + l.key] = l.en || l.de;
                }
            }
        }
        var lang = document.documentElement.getAttribute("lang");
        this.language = lang === "en-US" ? "en" : "de";
        this.lookup = lookup;
    }
}